import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { ApiService } from '../../utils/services/api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { LoaderService } from 'src/app/utils/services/loader.service';

@Component({
  selector: 'app-dashboard-video',
  templateUrl: './dashboard-video.component.html',
  styleUrls: ['./dashboard-video.component.scss']
})
export class DashboardVideoComponent implements OnInit {
  addVideoForm: FormGroup;
  private video_id: any;
  public video_type: any;
  public SubCats: any;
  public minDate = undefined;
  private _userId: string = localStorage.getItem("id");
  public isAuthLoading = false;
  public isAuthDisabled = false;
  postDate: { day: number; month: number; year: number; };

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private apiService: ApiService,
    private toastr: ToastrService,
    private LoaderService:LoaderService
  ) {
    const current = new Date();
    this.minDate = {
      year: current.getFullYear(),
      month: current.getMonth() + 1,
      day: current.getDate()
    };
  }
  @ViewChild('importVdo', { static: false }) importVdo: ElementRef;
  @ViewChild('importImg', { static: false }) importImg: ElementRef;
  @ViewChild('importLogoImg', { static: false }) importLogoImg: ElementRef;
  ngOnInit(): void {
    const today = new Date();
this.postDate={
  year: today.getFullYear(),
  month: today.getMonth() + 1,
  day: today.getDate()
};
    this.LoaderService.showLoader()
    this.addVideoForm = new FormGroup({
      video_type: new FormControl(),
      title: new FormControl(),
      logo_title: new FormControl(),
      link: new FormControl(),
      logo_link: new FormControl(),
      video: new FormControl(),
      img: new FormControl(),
      logo_img: new FormControl(),
      // description: new FormControl(),
      subCatName: new FormControl(),
      activeTillDate: new FormControl(),
      status: new FormControl(),
    });
    this.addVideoForm = this.formBuilder.group({
      video_type: ['', []],
      title: ['', [Validators.required]],
      logo_title: ['', [Validators.required]],
      link: ['', [Validators.required, Validators.pattern('https?://.+')]],
      logo_link: ['', [Validators.required]],
      logo_img: ['', [Validators.required]],
      // description: ['', [Validators.required]],
      video: ['', []],
      img: ['', [Validators.required]],
      subCatName: [[], [Validators.required]],
      activeTillDate: [null, Validators.required],
      status: ['', []],
    });

    this.getAllSubCat();

    this.video_id = this.route.snapshot.paramMap.get('videos_id');
    this.video_type = this.route.snapshot.paramMap.get('video_type');
    // console.log(this.news_id, this.news_type);
    if (this.video_id != undefined && this.video_id != '' && this.video_type != undefined && this.video_type != '') {
      this.editVideo(this.video_id, this.video_type.split(" ")[0]);
    } else {
      this.addVideoForm.get('video_type').setValue('internal_video');
      this.addVideoForm.get('status').setValue('active');
    }
  }

  getAllSubCat() {
    this.LoaderService.showLoader()

    this.apiService.getAllsubcatVideo().subscribe((resp: any) => {
      this.SubCats = [];
      for (let i = 0; i < resp.data.length; i++) {
        if (resp.data[i].status === "active") {
          this.SubCats.push(resp.data[i].sub_category_name);
        }
      }
      this.LoaderService.hideLoader()

    });
  }

  onFileChange(event, set) {
    this.LoaderService.showLoader();
  
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      
      if (set === 'img' && file.type.startsWith('image/')) {
        const reader = new FileReader();
        
        reader.onload = (e: any) => {
          const img = new Image();
          
          img.onload = () => {
            const width = img.width;
            const height = img.height;
            // if (width >= 700 && height >= 700) {
              this.LoaderService.hideLoader();
              this.addVideoForm.get(set).setValue(file);
              this.importImg.nativeElement.innerText = file.name;
            // } else {
              this.LoaderService.hideLoader();
              // this.toastr.error('Image must be bigger than 700x700 pixels.');
            // }
          };
          
          img.src = e.target.result;
        };
        reader.readAsDataURL(file);  
      } else {
        if (set === 'video' && file.type.startsWith('video/')) {
          this.LoaderService.hideLoader();
          this.addVideoForm.get(set).setValue(file);
          this.importVdo.nativeElement.innerText = file.name;
        } else if (set === 'logo_img' && file.type.startsWith('image/')) {
          this.LoaderService.hideLoader();
          this.addVideoForm.get(set).setValue(file);
          this.importLogoImg.nativeElement.innerText = file.name;
        } else {
          this.LoaderService.hideLoader();
          this.toastr.error('Invalid file type. Please upload the correct file.');
        }
      }
    }
  }
  
  


  async addVideo() {
    this.LoaderService.showLoader()

    if (
      this.addVideoForm.value.title.trim() == undefined ||
      this.addVideoForm.value.title.trim() == ''
    ) {
      this.LoaderService.hideLoader()

      this.toastr.error('All fields are required', '', {
        timeOut: 1000,  // Time in milliseconds (1000ms = 1 second)
        progressBar: true,  // Optional: Show progress bar
        closeButton: true   // Optional: Show close button
      });
          return false;
    }
    if (this.addVideoForm.value.video_type == 'external_video') {
      this.LoaderService.hideLoader()

      if (
        this.addVideoForm.value.link.trim() == undefined ||
        this.addVideoForm.value.link.trim() == ''
      ) {
        this.LoaderService.hideLoader()

        this.toastr.error('Please Enter Link');
        return false;
      }
    }
    // if (
    //   this.addVideoForm.value.description.trim() == undefined ||
    //   this.addVideoForm.value.description.trim() == ''
    // ) {
    //   this.toastr.error('Please Enter Video Description');
    //   return false;
    // }
    if (this.addVideoForm.value.subCatName.length === 0) {
      this.LoaderService.hideLoader()

      this.toastr.error('Please Select Sub-category');
      return false;
    }
    if (
      this.addVideoForm.value.activeTillDate == undefined ||
      this.addVideoForm.value.activeTillDate == '' ||
      this.addVideoForm.value.activeTillDate == null
    ) {
      this.LoaderService.hideLoader()

      this.toastr.error('Please Enter Active Till Date');
      return false;
    }

    if (this.video_id != undefined && this.video_id != '' && this.video_type != undefined && this.video_type != '') {
      this.updateVideo(this.video_id, this.video_type.split(" ")[0]);
      this.LoaderService.hideLoader()

    } else {
      this.LoaderService.hideLoader()

      if (this.addVideoForm.value.video_type == 'internal_video') {
        if (
          this.addVideoForm.value.video.name == undefined ||
          this.addVideoForm.value.video.name == ''
        ) {
          this.LoaderService.hideLoader()

          this.toastr.error('Please Select Video');
          return false;
        }
      }
      if (this.addVideoForm.value.video_type == 'external_video') {
        if (
          this.addVideoForm.value.img.name == undefined ||
          this.addVideoForm.value.img.name == ''
        ) {
          this.LoaderService.hideLoader()

          this.toastr.error('Please Select Image');
          return false
        }
      }
      this.isAuthLoading = true;
      this.isAuthDisabled = true;
      let date = `${this.addVideoForm.value.activeTillDate.month}/${this.addVideoForm.value.activeTillDate.day}/${this.addVideoForm.value.activeTillDate.year}`
      let formData = new FormData();
      if (this.addVideoForm.value.video_type == 'internal_video') {
        this.LoaderService.hideLoader()

        formData.append('user_id', this._userId);
        formData.append('status', this.addVideoForm.get('status').value);
        formData.append('all_video', this.addVideoForm.get('video').value);
        formData.append('title', this.addVideoForm.get('title').value);
        formData.append('active_till', date);
        // formData.append('description', this.addVideoForm.get('description').value);
        for (let i = 0; i < this.addVideoForm.value.subCatName.length; i++) {
          formData.append('sub[]', this.addVideoForm.get('subCatName').value[i]);
        }
        await this.apiService.addNewVideo(formData).subscribe((result: any) => {
          if (result.success) {
            this.LoaderService.hideLoader()

            this.isAuthLoading = false;
            this.isAuthDisabled = false;
            this.toastr.success(result.message);
            this.router.navigateByUrl('/videos-list');
          } else {
            this.LoaderService.hideLoader()

            this.isAuthLoading = false;
            this.isAuthDisabled = false;
            this.toastr.error(result.message);
          }
        });
      } else if (this.addVideoForm.value.video_type == 'external_video') {
        this.LoaderService.hideLoader()

        formData.append('user_id', this._userId);
        formData.append('status', this.addVideoForm.get('status').value);
        formData.append('all_images', this.addVideoForm.get('img').value);
        formData.append('all_images2', this.addVideoForm.get('logo_img').value);
        formData.append('title', this.addVideoForm.get('title').value);
        formData.append('logo_title', this.addVideoForm.get('logo_title').value);
        formData.append('link', this.addVideoForm.get('link').value);
        formData.append('logo_link', this.addVideoForm.get('logo_link').value);
        formData.append('active_till', date);
        // formData.append('description', this.addVideoForm.get('description').value);
        for (let i = 0; i < this.addVideoForm.value.subCatName.length; i++) {
          formData.append('sub[]', this.addVideoForm.get('subCatName').value[i]);
        }
        await this.apiService.addNewExternalVideo(formData).subscribe((result: any) => {
          if (result.success) {
            this.LoaderService.hideLoader()

            this.isAuthLoading = false;
            this.isAuthDisabled = false;
            this.toastr.success(result.message);
            this.router.navigateByUrl('/videos-list');
          } else {
            this.LoaderService.hideLoader()

            this.isAuthLoading = false;
            this.isAuthDisabled = false;
            this.toastr.error(result.message);
          }
        });
      }
    }

  }

  async editVideo(id, type) {
    this.LoaderService.showLoader()
    let dataForForm = {
      id: id,
    };
    if (type === 'Internal') {
      await this.apiService.getVideoById(dataForForm).subscribe((result: any) => {
        if (result.success) {
          this.LoaderService.hideLoader()
          console.log(result.getData);
          let videoData: any = result.getData;
          this.addVideoForm.get('video_type').setValue('internal_video');
          this.addVideoForm.get('subCatName').setValue(videoData.sub_category_name);
          let date = new Date(videoData.active_till);
          let post=new Date(videoData.created_at)
          this.postDate= {
            day: post.getUTCDate() ,
            month: post.getUTCMonth(),
            year: post.getUTCFullYear()
        }
          this.addVideoForm.patchValue({
            title: videoData.title,
            video: videoData.video_file[0]?.src,
            // description: videoData.description,
            activeTillDate: {
              day: date.getUTCDate() ,
              month: date.getUTCMonth() + 1,
              year: date.getUTCFullYear()
            },
          });
          if (videoData.status == "active") {
            this.LoaderService.hideLoader()
            this.addVideoForm.get('status').setValue('active');
          }
          setTimeout(() => {
            this.importVdo.nativeElement.innerText = videoData.video_file[0]?.orgName;
          }, 1000);
        } else {
          this.LoaderService.hideLoader()
          this.toastr.error(result.message);
        }
      });
    } else if (type === 'External') {
      await this.apiService.getExternalVideoById(dataForForm).subscribe((result: any) => {
        if (result.success) {
          this.LoaderService.hideLoader()
          console.log(result.getData);
          let videoData: any = result.getData;
          this.addVideoForm.get('video_type').setValue('external_video');
          this.addVideoForm.get('subCatName').setValue(videoData.sub_category_name);
          let date = new Date(videoData.active_till);
          let post=new Date(videoData.created_at)
          this.postDate= {
            day: post.getUTCDate() ,
            month: post.getUTCMonth(),
            year: post.getUTCFullYear()
        }
          this.addVideoForm.patchValue({
            title: videoData.title,
            img: videoData.news_image[0]?.src,
            // video: videoData.video_file[0]?.src,
            // description: videoData.description,
            link: videoData.link,
            logo_title: videoData.logo_title,
            logo_img: videoData.logo_image[0]?.src,
            logo_link: videoData.logo_link,
            activeTillDate: {
              day: date.getUTCDate() ,
              month: date.getUTCMonth() + 1,
              year: date.getUTCFullYear()
            },
          });
          if (videoData.status == "active") {
            this.LoaderService.hideLoader()
            this.addVideoForm.get('status').setValue('active');
          }
          setTimeout(() => {
            this.importImg.nativeElement.innerText = videoData.news_image[0]?.orgName;
            if (
              videoData.logo_image[0]?.orgName === undefined ||
              videoData.logo_image[0]?.orgName === '' ||
              videoData.logo_image[0]?.orgName === null
            ) {
              this.LoaderService.hideLoader()
              this.importLogoImg.nativeElement.innerText = 'Upload Logo Image';
            } else {
              this.LoaderService.hideLoader()
              this.importLogoImg.nativeElement.innerText = videoData.logo_image[0]?.orgName;
            }
          }, 1000);
        } else {
          this.LoaderService.hideLoader()
          this.toastr.error(result.message);
        }
      });
    }
  }

  async updateVideo(id, type) {
    this.LoaderService.showLoader()

    let formData = new FormData();
    if (type == 'Internal') {
      if (
        this.addVideoForm.value.video?.name != undefined ||
        this.addVideoForm.value.video?.name != ''
      ) {
        this.LoaderService.hideLoader()
        formData.append('all_video', this.addVideoForm.get('video').value);
      }
    }
    if (type == 'External') {
      if (
        this.addVideoForm.value.img?.name != undefined ||
        this.addVideoForm.value.img?.name != ''
      ) {
        formData.append('all_images', this.addVideoForm.get('img').value);
      }
      if (
        this.addVideoForm.value.logo_img?.name != undefined ||
        this.addVideoForm.value.logo_img?.name != ''
      ) {
        formData.append('all_images2', this.addVideoForm.get('logo_img').value);
      }
    }
    this.isAuthLoading = true;
    this.isAuthDisabled = true;
    let date = `${this.addVideoForm.value.activeTillDate.month}/${this.addVideoForm.value.activeTillDate.day}/${this.addVideoForm.value.activeTillDate.year}`

    if (type == 'Internal') {
      formData.append('status', this.addVideoForm.get('status').value == "" || this.addVideoForm.get('status').value == "inactive" ? "inactive" : "active");
      formData.append('user_id', this._userId);
      formData.append('title', this.addVideoForm.get('title').value);
      formData.append('active_till', date);
      // formData.append('all_video', this.addVideoForm.get('video').value);
      // formData.append('description', this.addVideoForm.get('description').value);
      for (let i = 0; i < this.addVideoForm.value.subCatName.length; i++) {
        formData.append('sub[]', this.addVideoForm.get('subCatName').value[i]);
      }

      await this.apiService.updateVideo(formData, id).subscribe((result: any) => {
        if (result.success) {
          this.LoaderService.hideLoader()
          this.isAuthLoading = false;
          this.isAuthDisabled = false;
          this.toastr.success(result.message);
          this.router.navigateByUrl('/videos-list');
        } else {
          this.LoaderService.hideLoader()
          this.isAuthLoading = false;
          this.isAuthDisabled = false;
          this.toastr.error(result.message);
        }
      });
    } else if (type == 'External') {
      formData.append('status', this.addVideoForm.get('status').value == "" || this.addVideoForm.get('status').value == "inactive" ? "inactive" : "active");
      formData.append('user_id', this._userId);
      formData.append('title', this.addVideoForm.get('title').value);
      formData.append('logo_title', this.addVideoForm.get('logo_title').value);
      formData.append('link', this.addVideoForm.get('link').value);
      formData.append('logo_link', this.addVideoForm.get('logo_link').value);
      formData.append('active_till', date);
      // formData.append('all_video', this.addVideoForm.get('video').value);
      // formData.append('description', this.addVideoForm.get('description').value);
      for (let i = 0; i < this.addVideoForm.value.subCatName.length; i++) {
        formData.append('sub[]', this.addVideoForm.get('subCatName').value[i]);
      }

      await this.apiService.updateExternalVideo(formData, id).subscribe((result: any) => {
        if (result.success) {
          this.LoaderService.hideLoader()
          this.isAuthLoading = false;
          this.isAuthDisabled = false;
          this.toastr.success(result.message);
          this.router.navigateByUrl('/videos-list');
        } else {
          this.LoaderService.hideLoader()
          this.isAuthLoading = false;
          this.isAuthDisabled = false;
          this.toastr.error(result.message);
        }
      });
    }
    // this.LoaderService.hideLoader()
  }
  handleChange(eve) {
    var target = eve.target;
    if (target.checked) {
      this.LoaderService.hideLoader()
      // document.getElementById('').setValue('')
      this.addVideoForm.get('title').setValue('')
      this.addVideoForm.get('subCatName').setValue('')
      this.addVideoForm.value.active_till == ''
      console.log('checked')
    }
  }

}
